import { detect } from "detect-browser";
class UserUtils {
  isBrowserSupported() {
    const browser = this.getBrowser();
    let result = true;
    switch (browser && browser.name) {
      case "chrome":
      case "edge":
      case "safari":
      case "firefox":
      case "ios":
        result = true;
        break;
      default:
        result = false;
    }
    return result;
  }
  getBrowser() {
    const browser = detect();
    return browser;
  }
  getAliasFromEmail(email) {
    let alias = email;
    if (!!email && email.includes("@")) {
      alias = email.substring(0, email.indexOf("@"));
    } else if (!email) {
      alias = "";
    }
    return alias;
  }
}
const UserUtilsInstance = new UserUtils();
export {
  UserUtils,
  UserUtilsInstance
};
//# sourceMappingURL=UserUtils.js.map
